"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AllowedUtms = _interopRequireDefault(require("./AllowedUtms"));

var _UtmsToPath;

var UtmsToPath = (_UtmsToPath = {}, (0, _defineProperty2.default)(_UtmsToPath, _AllowedUtms.default.UTM_SOURCE, 'utm_source'), (0, _defineProperty2.default)(_UtmsToPath, _AllowedUtms.default.UTM_MEDIUM, 'utm_medium'), (0, _defineProperty2.default)(_UtmsToPath, _AllowedUtms.default.UTM_ID, 'utm_id'), _UtmsToPath);
var _default = UtmsToPath;
exports.default = _default;
module.exports = exports.default;